
define('text!modules/util/collection/list_item_template.html',[],function () { return '<li class="collection-item"></li>\r\n';});

